<template>
  <div class="specialEdition">
    <div class="detailsTitle">
      <div class="detailsWrap"></div>
      <p>專輯</p>
    </div>
    <el-form>
      <el-form-item label='專輯名稱 ：'>
        <input maxlength="100" class="el-input__inner" type="text" v-model="specialEdition.name">
      </el-form-item>
      <el-form-item label='專輯語言 ：'>
        <input maxlength="100" class="el-input__inner" type="text" v-model="specialEdition.albumLanguage">
      </el-form-item>
      <el-form-item label="發行日期 ：">
        <el-date-picker v-model="specialEdition.issueDate" type="month" placeholder="選擇時間"></el-date-picker>
      </el-form-item>
      <el-form-item label="唱片公司 ：">
        <input maxlength="100" class="el-input__inner" type="text" v-model="specialEdition.company">
      </el-form-item>
      <el-form-item label='專輯順序 ：'>
        <input class="el-input__inner" type="text" v-model="specialEdition.inorder"
               @change="specialEdition.inorder=specialEdition.inorder.replace(/^(0+)|[^\d]+/g,'')">
      </el-form-item>
      <el-form-item label="專輯主圖 ：" class="picupload">
        <el-upload
          action=''
          :http-request='uploadRequest'
          :headers="{'Authorization': this.$cookie.get('auth')}"
          :with-credentials="true"
          :on-remove="mainHandleRemove"
          :on-error='$errorImage'
          :file-list="mainList"
          :on-exceed="$handleExceed.bind(this, 1)"
          :on-change="handleChange"
          :before-upload="beforePicUpload"
          :limit=1
          accept=".jpg,.jpeg,.png"
          :multiple='false'
          name='mainPC'
          list-type="picture-card">
          <el-button size="small" type="primary">選擇圖片</el-button>
          <div slot="tip" class="el-upload__tip">支持jpg/png格式(適配web端)</div>
        </el-upload>
        <el-upload
          action=''
          :http-request='uploadRequest'
          :headers="{'Authorization': this.$cookie.get('auth')}"
          :with-credentials="true"
          :on-remove="mainAppHandleRemove"
          :on-error='$errorImage'
          :file-list="mainAppList"
          :on-exceed="$handleExceed.bind(this, 1)"
          :on-change="handleChange"
          :before-upload="beforePicUpload"
          :limit=1
          accept=".jpg,.jpeg,.png"
          :multiple='false'
          name='mainApp'
          list-type="picture-card">
          <el-button size="small" type="primary">選擇圖片</el-button>
          <div slot="tip" class="el-upload__tip">支持jpg/png格式(適配app端)</div>
        </el-upload>
      </el-form-item>
    </el-form>
    <div class="detailsTitle">
      <div class="detailsWrap"></div>
      <p>專輯詳情</p>
    </div>
    <el-form>
      <el-form-item label="詳情主圖 ：" class="picupload">
        <el-upload
          action=''
          :http-request='uploadRequest'
          :headers="{'Authorization': this.$cookie.get('auth')}"
          :with-credentials="true"
          :on-remove="detailHandleRemove"
          :on-error='$errorImage'
          :file-list="detailList"
          :on-exceed="$handleExceed.bind(this, 1)"
          :on-change="handleChange"
          :before-upload="beforePicUpload"
          :limit=1
          accept=".jpg,.jpeg,.png"
          :multiple='false'
          name='detailsPC'
          list-type="picture-card">
          <el-button size="small" type="primary">選擇圖片</el-button>
          <div slot="tip" class="el-upload__tip">支持jpg/png格式(適配web端)</div>
        </el-upload>
        <el-upload
          action=''
          :http-request='uploadRequest'
          :headers="{'Authorization': this.$cookie.get('auth')}"
          :with-credentials="true"
          :on-remove="detailAppHandleRemove"
          :on-error='$errorImage'
          :file-list="detailAppList"
          :on-exceed="$handleExceed.bind(this, 1)"
          :on-change="handleChange"
          :before-upload="beforePicUpload"
          :limit=1
          accept=".jpg,.jpeg,.png"
          :multiple='false'
          name='detailsApp'
          list-type="picture-card">
          <el-button size="small" type="primary">選擇圖片</el-button>
          <div slot="tip" class="el-upload__tip">支持jpg/png格式(適配app端)</div>
        </el-upload>
      </el-form-item>

      <el-form-item label="上傳試聽歌曲 ：" class="picupload">
        <el-upload
          action=''
          :http-request='uploadRequest'
          :with-credentials="true"
          :headers="{'Authorization': this.$cookie.get('auth')}"
          :on-error='$errorImage'
          :on-exceed="audiohandleExceed"
          :on-remove="handleAudioRemove"
          :file-list="audioFile"
          :before-upload="beforeAudioUpload"
          :limit=1
          accept=".mp3"
          :multiple='false'
          name='audio'>
          <el-button size="small" type="primary">選擇音頻文件</el-button>
        </el-upload>
      </el-form-item>

      <el-form-item label='專輯鏈接 ：'>
        <input maxlength="100" class="el-input__inner" type="text" v-model="specialEdition.hyperlink">
      </el-form-item>

      <el-form-item label="歌曲詳情 ：" class="songWrap">

        <div class="songDetail" v-for="(item, index) in songDetail" :key="index">

          <div class="songDetailLeft">
            <input v-model="item.single" placeholder="請輸入歌曲名稱" class="el-input__inner songInput" type="text">
          </div>
          <div class="songDetailRight">
            <input v-model="item.link" placeholder="請輸入歌曲鏈接" class="el-input__inner songInput" type="text">
          </div>

          <span v-show="!(index === 0)" class="delBtn" @click="delSongDetail(index, songDetail)">删除</span>

        </div>
      </el-form-item>

      <el-form-item class="addWrap">
        <div v-show="!(songDetail.length >= 30)" class="addSongDetail" @click="addSongDetail()">添加</div>
      </el-form-item>

      <el-form-item label='詳情介紹 ：'>
        <input class="el-input__inner" type="text" v-model="specialEdition.content">
      </el-form-item>
    </el-form>
    <div class="bottomBtn">
      <div class="btn" @click="submitContent()">發佈</div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>

  </div>
</template>

<script>
import NavBar from '@/components/navBar';
import DiaMess from '@/components/dialog';

export default {
  props: ['type', 'id'],
  data() {
    return {
      specialEdition: {
        name: '',// 专辑名称
        issueDate: '',// 专辑发行时间
        inorder: '',// 专辑顺序
        albumLanguage: '',//专辑语言
        company: '',//唱片公司
        hyperlink: '',//专辑链接
        content: '',//详情介绍
      },
      mainList: [],
      mainAppList: [],
      detailList: [],
      detailAppList: [],
      songDetail: [
        {
          aid: '',
          id: '',
          link: '',
          single: '',
          sequence: 1
        }
      ],
      dialogVisible: false,
      audioFile: []
    }
  },
  created() {
    let _this = this
    if (_this.type === 'edit') {
      _this.getSpecialEditionDetails();
    } else {
    }
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    // 编辑之前查询专辑信息
    getSpecialEditionDetails() {
      let _this = this;
      _this.$get(`/request/album/searchAlbum/${_this.id}`, {}, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === '00000') {
            console.log(res);
            _this.specialEdition = {
              name: res.data.album,
              issueDate: res.data.releaseDate.substring(0, 7),
              inorder: res.data.sequence,
              albumLanguage: res.data.albumLanguage,
              company: res.data.company,
              content: res.data.content,
              hyperlink: res.data.hyperlink
            };
            _this.mainList.push({name: 'img.jpg', url: res.data.albumCoverWeb});
            document.getElementsByClassName('el-upload')[0].style.display = 'none';

            _this.mainAppList.push({name: 'img.jpg', url: res.data.albumCoverAPP});
            document.getElementsByClassName('el-upload')[1].style.display = 'none';

            _this.detailList.push({name: 'img.jpg', url: res.data.detailCoverWeb});
            document.getElementsByClassName('el-upload')[2].style.display = 'none';

            _this.detailAppList.push({name: 'img.jpg', url: res.data.detailCoverApp});
            document.getElementsByClassName('el-upload')[3].style.display = 'none';

            _this.songDetail = res.data.albumDetailDto;
            if(!!res.data.listeningTest){
              _this.audioFile.push({url: res.data.listeningTest});
            }
          } else {
            _this.$Mint.Toast(res.message);
          }
        });
    },

    beforeAudioUpload(file) {
      const isAudio = file.type.includes('audio');
      if(!isAudio){
        this.dialogVisible = true;
        this.$propMessage('請上傳音頻文件', 'error', function () {
          this.dialogVisible = false;
        });
        return false;
      }
      return isAudio;
    },
    // 上传图片之前的回调函数
    beforePicUpload(file) {
      let _this = this;
      const isJPG = (file.type === 'image/jpeg') || (file.type === 'image/png');
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isJPG) {
        _this.dialogVisible = true;
        _this.$propMessage('上傳圖片只能是jpg或者png格式', 'error', function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (!isLt2M) {
        _this.dialogVisible = true;
        _this.$propMessage('上傳圖片小大不能超過20MB', 'error', function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      const isWidth = new Promise((resolve, reject) => {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          if (img.width > 3000 || file.size > 1024 * 1024 * 2) {
            _this.$imageConversion.compress(file, {
              quality: 0.3,
              width: 3000,
            }).then(res => {
              resolve(res);
            })
          } else {
            resolve(file);
          }
        }
        img.src = _URL.createObjectURL(file);
      })
      return isJPG && isLt2M && isWidth;
    },
    // 专辑主图pc
    mainHandleRemove(file, fileList) {
      this.$deleteUidItem(file.uid, this.mainList);
      document.getElementsByClassName('el-upload')[0].style.display = 'inline-block';
    },
    // 专辑主图app
    mainAppHandleRemove(file, fileList) {
      this.$deleteUidItem(file.uid, this.mainAppList);
      document.getElementsByClassName('el-upload')[1].style.display = 'inline-block';
    },
    // 专辑详情pc
    detailHandleRemove(file, fileList) {
      this.$deleteUidItem(file.uid, this.detailList);
      document.getElementsByClassName('el-upload')[2].style.display = 'inline-block';
    },
    // 专辑详情app
    detailAppHandleRemove(file, fileList) {
      this.$deleteUidItem(file.uid, this.detailAppList);
      document.getElementsByClassName('el-upload')[3].style.display = 'inline-block';
    },
    // 上传图片
    uploadRequest(option) {
      const file = option.file
      const self = this
      return new Promise((resolve, reject) => {
        const date = self.$dateFormat(new Date(), 'yyyy-MM-dd') // 当前时间
        const dateTime = self.$dateFormat(new Date(), 'yyyyMMddhhmmss') // 当前时间
        let randomStr = self.$randomString(4)//  4位随机字符串
        const extensionName = file.name.substr(file.name.indexOf('.')) // 文件扩展名
        const fileWay = 'resource/image/'
        const fileName = fileWay + date + '/' + dateTime + '_' + randomStr + extensionName // 文件名字（相对于根目录的路径 + 文件名）
        // 执行上传
        self.$createOssClient().then(client => {
          // 异步上传,返回数据
          // resolve({
          //   fileName: file.name,
          //   fileUrl: fileName // 图片路径
          // })
          // 上传处理
          // 分片上传文件
          client.multipartUpload(fileName, file, {headers: {'Cache-Control': 'public'}})
            .then((val) => {
              if (val.res.statusCode === 200) {
                if (option.filename === 'mainPC') { // 列表主图横图
                  self.mainList.push({url: self.$GLOBAL.picFileUrl + val.name}); // 展示图片
                  //cdn预热
                  self.$cdnFun(self.mainList[0].url).then(res => {
                    console.log(res)
                  })
                  document.getElementsByClassName('el-upload')[0].style.display = 'none';
                } else if (option.filename === 'mainApp') { // 列表主图竖图
                  self.mainAppList.push({url: self.$GLOBAL.picFileUrl + val.name}); // 展示图片
                  //cdn预热
                  self.$cdnFun(self.mainAppList[0].url).then(res => {
                    console.log(res)
                  })
                  document.getElementsByClassName('el-upload')[1].style.display = 'none';
                } else if (option.filename === 'detailsPC') { // 活动详情主图竖图
                  self.detailList.push({url: self.$GLOBAL.picFileUrl + val.name}); // 展示图片
                  //cdn预热
                  self.$cdnFun(self.detailList[0].url).then(res => {
                    console.log(res)
                  })
                  document.getElementsByClassName('el-upload')[2].style.display = 'none';
                } else if (option.filename === 'detailsApp') { // 活动详情主图横图
                  self.detailAppList.push({url: self.$GLOBAL.picFileUrl + val.name}); // 展示图片
                  //cdn预热
                  self.$cdnFun(self.detailAppList[0].url).then(res => {
                    console.log(res)
                  })
                  document.getElementsByClassName('el-upload')[3].style.display = 'none';
                }else if(option.filename === 'audio'){
                  self.audioFile.push({url: self.$GLOBAL.picFileUrl + val.name});
                  self.$cdnFun(self.audioFile[0].url).then(res => {
                    console.log(res);
                  });
                }

                return val
              } else {
                option.onError('上传失败1')
              }
            }, err => {
              console.log(err)
              option.onError('上传失败')
              reject(err)
            })
        })
      })
    },
    handleChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    audiohandleExceed() {
      let _this = this;
      _this.dialogVisible = true;
      _this.$propMessage('最多上傳一條音頻', 'error', function () {
        _this.dialogVisible = false;
      });
      return false;
    },
    // 移除音频
    handleAudioRemove(file) {
      this.$deleteUidItem(file.uid, this.audioFile);
      this.$Mint.Toast({message: '刪除成功'});
      document.getElementsByClassName('el-upload')[3].style.display = 'inline-block';
      return false;
    },
    // 删除专辑详情歌曲选项
    delSongDetail(index, itemList) {
      itemList.splice(index, 1)
    },
    // 添加专辑详情歌曲选项
    addSongDetail() {
      let _this = this
      let songLength = _this.songDetail.length;
      if (_this.type === 'add') {
        _this.songDetail.push({aid: '', id: '', link: '', single: '', sequence: songLength + 1})
      } else if (_this.type === 'edit') {
        _this.songDetail.push({aid: Number(_this.id), id: '', link: '', single: '', sequence: songLength + 1})
      }
    },
    checkSubmit () {


      let _this = this;
      if (_this.specialEdition.name === '' || _this.$getCaption(_this.specialEdition.name)) {
        _this.dialogVisible = true;
        _this.$propMessage('專輯名稱不能為空或者含有非法字符', 'error', function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      // if (_this.specialEdition.albumLanguage === '' || _this.$getCaption(_this.specialEdition.albumLanguage)) {
      //   _this.dialogVisible = true;
      //   _this.$propMessage('專輯語言不能為空或者含有非法字符', 'error', function () {
      //     _this.dialogVisible = false;
      //   });
      //   return false;
      // }
      if (_this.specialEdition.issueDate === '') {
        _this.dialogVisible = true;
        _this.$propMessage('發行日期不能為空', 'error', function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (_this.specialEdition.inorder === '') {
        _this.dialogVisible = true;
        _this.$propMessage('專輯順序不能為空', 'error', function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (_this.mainList.length === 0) {
        _this.dialogVisible = true;
        _this.$propMessage('專輯主圖(適配web端)不能為空', 'error', function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (_this.mainAppList.length === 0) {
        _this.dialogVisible = true;
        _this.$propMessage('專輯主圖(適配app端)不能為空', 'error', function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (_this.detailList.length === 0) {
        _this.dialogVisible = true;
        _this.$propMessage('專輯詳情主圖(適配web端)不能為空', 'error', function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (_this.detailAppList.length === 0) {
        _this.dialogVisible = true;
        _this.$propMessage('專輯詳情主圖(適配app端)不能為空', 'error', function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      for (var key in _this.songDetail) {
        if (_this.songDetail[key].single === '' || _this.songDetail[key].link === '' || _this.$getCaption(_this.songDetail[key].single) || _this.$getCaption(_this.songDetail[key].link)) {
          _this.dialogVisible = true;
          _this.$propMessage('專輯詳情不能有選項為空或者含有非法字符', 'error', function () {
            _this.dialogVisible = false;
          });
          return false
        }
      }
      // if (_this.$getCaption(_this.specialEdition.company)) {
      //   _this.dialogVisible = true;
      //   _this.$propMessage('唱片公司不能含有非法字符', 'error', function () {
      //     _this.dialogVisible = false;
      //   });
      //   return false;
      // }
      if (!!_this.specialEdition.hyperlink && _this.$getCaption(_this.specialEdition.hyperlink)) {
        _this.dialogVisible = true;
        _this.$propMessage('專輯鏈接不能含有非法字符', 'error', function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (!!_this.specialEdition.content && _this.$getCaption(_this.specialEdition.content)) {
        _this.dialogVisible = true;
        _this.$propMessage('詳情介紹不能含有非法字符', 'error', function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      return true;

    },
    // 提交内容
    submitContent() {
      let _this = this;
      if(!this.checkSubmit()){
        return;
      }
      let url = _this.audioFile.length > 0? _this.audioFile[0].url: '';
      // 新增专辑
      if (_this.type === 'add') {
        let param = {
          album: _this.specialEdition.name,
          albumCoverWeb: _this.mainList[0].url,
          albumCoverAPP: _this.mainAppList[0].url,
          albumDetailDto: _this.songDetail,
          detailCoverWeb: _this.detailList[0].url,
          detailCoverApp: _this.detailAppList[0].url,
          releaseDate: _this.$formatDate(_this.specialEdition.issueDate).substring(0, 10),
          sequence: _this.specialEdition.inorder,
          company: _this.specialEdition.company,
          hyperlink: _this.specialEdition.hyperlink,
          content: _this.specialEdition.content,
          albumLanguage: _this.specialEdition.albumLanguage,
          listeningTest: url
        };
        _this.$post('/request/album/saveAlbum', param, _this.$GLOBAL.jsonConfig)
          .then((res) => {
            _this.dialogVisible = true;
            if (res.code === '00000') {

              _this.$propMessage('新增專輯成功', 'success',
                function () {
                  _this.dialogVisible = false;
                  _this.$router.push('/specialEditionList');
                });
            } else {
              _this.$propMessage(res.message, 'error',
                function () {
                  _this.dialogVisible = false;
                });
            }
          })
      } else if (_this.type === 'edit') {
        // 编辑专辑
        let editParam = {
          album: _this.specialEdition.name,
          albumCoverWeb: _this.mainList[0].url,
          albumCoverAPP: _this.mainAppList[0].url,
          albumDetailDto: _this.songDetail,
          detailCoverWeb: _this.detailList[0].url,
          detailCoverApp: _this.detailAppList[0].url,
          releaseDate: typeof _this.specialEdition.issueDate === 'string' ? _this.specialEdition.issueDate + '-01' : _this.$formatDate(_this.specialEdition.issueDate).substring(0, 10),
          sequence: _this.specialEdition.inorder,
          id: Number(_this.id),
          company: _this.specialEdition.company,
          hyperlink: _this.specialEdition.hyperlink,
          content: _this.specialEdition.content,
          albumLanguage: _this.specialEdition.albumLanguage,
          listeningTest: url
        };
        _this.$post('/request/album/updateAlbum', editParam, _this.$GLOBAL.jsonConfig)
          .then((res) => {
            _this.dialogVisible = true;
            if (res.code === '00000') {
              _this.$propMessage('編輯專輯成功', 'success',
                function () {
                  _this.dialogVisible = false;
                  _this.$router.push('/specialEditionList');
                });
            } else {
              _this.$propMessage(res.message, 'error',
                function () {
                  _this.dialogVisible = false;
                });
            }
          })
      }
      ;
    }
  },
  components: {
    NavBar,
    DiaMess
  }
};
</script>

<style lang="less" scoped>
.specialEdition {
  .songWrap {
    .songDetail {
      margin-bottom: .2rem;
      display: flex;

      input.songInput {
        width: 3rem;
      }

      .songDetailLeft, .songDetailRight {
      }

      .songDetailRight {
        margin-left: 0.4rem;
      }

      .delBtn {
        display: inline-block;
        margin: 0 0.1rem 0 0.24rem;
        cursor: pointer;
        line-height: 40px;
        color: rgba(108, 61, 234, 1);
        white-space: nowrap;
      }
    }
  }

  input:disabled {
    background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: #C0C4CC;
    cursor: not-allowed;
  }

  .addSongDetail {
    float: right;
    margin-right: 1.98rem;
    margin-top: -0.08rem;
    width: 1rem;
    height: .36rem;
    line-height: 0.36rem;
    text-align: center;
    background: rgba(242, 240, 247, 1);
    color: rgba(147, 142, 164, 1);
    border-radius: 0.04rem;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/specialEdition.vue